import React, { useEffect, useState } from 'react';
import CenterPanel from './centerPanel';
import { useDispatch, useSelector } from 'react-redux';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import AccordionSession from './accordion';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import PageHeader from '../../header';
import EditPortalSettingsModal from '../editPortalSetting/content';

import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import ScrollToTopButton from '../../../shared/scrollToTopBtn/content';

export default function PortalSettingsLisingPage(props) {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [isOnMobileOrTablet, setIsOnMobileOrTablet] = useState(
    window.innerWidth < window.styleVariable.computerMinWidth
  );
  const portalSettingsFromRedux = useSelector((state) => state.portalSettingReducer.portalSettings);
  const bottomSession = <AccordionSession userId={props.userId} />;

  useEffect(() => {
    window.addEventListener('resize', (event) =>
      setIsOnMobileOrTablet(window.innerWidth < window.styleVariable.computerMinWidth)
    );

    return () => {
      window.removeEventListener('resize', (event) =>
        setIsOnMobileOrTablet(window.innerWidth < window.styleVariable.computerMinWidth)
      );
    };
  }, []);

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
  };
  return (
    <div>
      <div className="main-ui-container manage-users-all-container waiting-area-view-one new-waiting-area-view-one">
        {!isOnMobileOrTablet ? (
          <Container fluid className="row">
            <div className="left-hand-side-panel">
              <div className="relative">
                <PageHeader
                  title={APP.LANGUAGE.AdminMenu.ManagePortalSettings}
                  titleColor="color-primary-dark-grey"
                  notRenderLogo={true}
                >
                  <span>
                    <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.MeetingRoomIcon.default} />
                  </span>
                </PageHeader>
              </div>
              <div className="pdlm pdrm">
                <CenterPanel
                  portalSettings={portalSettingsFromRedux}
                  searchTerm={searchTerm}
                  handleSearchTerm={handleSearchTerm}
                />
              </div>
            </div>

            <div className="right-hand-side-panel color-right-hand-side-panel-bg">
              <RightPanelOrTopPanel
                allUsersSearchForm={props.allUsersSearchForm}
                dispatch={dispatch}
                bottomSession={bottomSession}
              />
            </div>
          </Container>
        ) : (
          <Container fluid>
            <div className="left-hand-side-panel-mobile">
              <PageHeader
                title={APP.LANGUAGE.AdminMenu.ManagePortalSettings}
                titleColor="color-primary-dark-grey"
                notRenderLogo={true}
              >
                <span>
                  <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.MeetingRoomIcon.default} />
                </span>
              </PageHeader>
              <div>
                <CenterPanel
                  portalSettings={portalSettingsFromRedux}
                  searchTerm={searchTerm}
                  handleSearchTerm={handleSearchTerm}
                />
              </div>
              <div className="mrtl right-hand-side-bottom-on-mobile">
                {bottomSession}
                <BottomLogo />
              </div>
            </div>
          </Container>
        )}
      </div>
      <EditPortalSettingsModal />
    </div>
  );
}
